import React, { FunctionComponent } from 'react';
import RpalForm, { RpalFormValues } from './RpalForm';
import { useCheckout } from '@bigcommerce/checkout/payment-integration-api';
import { RpalSessionStorage } from './RpalSessionStorage';

export interface RpalProps {
    onSubmit(): void
}

const RpalCheckoutSection: FunctionComponent<RpalProps> = (
    { onSubmit }
) => {

    const {
        checkoutState: {
            data: { getCart }
        }
    } = useCheckout();

    const handleSubmit = async (values: RpalFormValues) => {

        const data = getCart();

        console.log("Order Data:")
        console.log(data);

        console.log("Submit RPAL Data")
        console.log(values);

        // This is the part that matters, the backend URL shouldnt ever change, but in the case it does
        let rpalNumber = "";
        if(values.rpalNumber.includes(".")){
            rpalNumber = values.rpalNumber.split(".")[0];
        }
        else{
            rpalNumber = values.rpalNumber;
        }

        var res = await fetch("https://rpal-wolverine.telosone.ca/api/rpaldata", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "IIYS04az9pmXNs6pQqRaFRTnUvECxfN3"
            },
            body: JSON.stringify({
                "rpalId": rpalNumber,
                "rpalEmail": values.rpalEmail,
                "bigCommerceID": data?.id,
                "firstName": values.fName,
                "lastName": values.lName,
                "dateOfBirth": values.dob,
                "rpalExpirationDate": values.expire,
                "cityOfBirth": values.city,
                "clubName": "noclub:)"
            })
        })

        if (!res.ok) {
            console.log("Failed to save RPAL Data!!")
            console.log(await res.text())
        }
        else{
            console.log("fetched!")
            // Mark RPAL as completed in session storage
            RpalSessionStorage.setRpalCompleted(true);
        }

        onSubmit();
        return;
    }


    return (
        <RpalForm
            onSubmit={handleSubmit}
        />
    )
}

export default RpalCheckoutSection;